import { useContext } from 'react';

import { CreateWorkspaceDataContext } from './CreateWorkspaceDataProvider';

const useCreateWorkspaceDataContext = () => {
  const context = useContext(CreateWorkspaceDataContext);
  if (!context) {
    throw new Error('useCreateWorkspaceDataContext must be used within a CreateWorkspaceDataProvider');
  }
  return context;
};

export default useCreateWorkspaceDataContext;
